import React, { useState, useEffect } from "react";
import { Grid, FormControlLabel, Checkbox } from "@mui/material";
import { H3, H4 } from "../../components/Typography";
import { load, remove } from "../../constants/storage";
import { useAppDispatch } from "../../store/hooks";
import DashboardNavbar from "../../components/DashboardNavbar";
import * as Models from "../../models";
import { toast } from "react-hot-toast";
import {
  getMFHoldings,
  redeemMutualFund,
  otpGenerateForMutualFund,
  otpVerifyForMutualFund,
  createSIPMandate,
  orderMutualFund,
  orderLumpsumMutualFund
} from "../../redux/actions/PortfolioAction";
import CircularProgress from "@mui/material/CircularProgress";
import aesEncrypt from "../../constants/aesEncrypt";
import MyHoldingCard from "../../components/MyHoldingCard";
import OTPModel from "../../components/OTPModel";
import { useNavigate } from "react-router-dom";
export default function MFMyHoldings() {
  const dispatch = useAppDispatch();
  const [onMoreSelect, setOnMoreSelect] = useState<number>(-1);
  const [onInvestSelect, setOnInvestSelect] = useState<number>(-1);
  const [onRedeemSelect, setOnRedeemSelect] = useState<number>(-1);
  const [onDefaultSelect, setOnDefaultSelect] = useState<any>(-1);
  const [redeemData, setRedeemData] = useState<any>();
  const [selected, setSelected] = useState<number>(-1);
  useEffect(() => {
    checkToken();
  }, []);
  const [unitsForRedeemption, setUnitsForRedeemption] = useState<any>();

  let navigate = useNavigate();

  const [mfHoldingList, setMfHoldingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allMfHoldingList, setAllMfHoldingList] = React.useState([]);
  const [isFullRedeem, setIsFullRedeem] = React.useState<boolean>(false);
  const [requestID, setRequestID] = React.useState("");
  const [InvestedType, setInvestedType] = useState("");
  //data save
  const [selectedDate, setselectedDate] = useState("");
  const [sipAmmount, setSipAmount] = useState("");
  const [additionalAmount, setAdditionalAmount] = useState("");
  const [selectedItemData, setSelectedItemData] = useState("");
  const [showAll, setShowAll] = useState<boolean>(false);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getMutualFundHoldingTransactions();
    }
  };

  const getMutualFundHoldingTransactions = async () => {
    setLoading(true);
    let token = await load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.MutualFundKYCRequestStatus = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
    };
    dispatch(getMFHoldings(req, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCode === 400) {
          return;
        }

        const AMountedList = response?.holdings?.folios?.filter(
          (item: any) => item?.schemes[0]?.holdings?.redeemable_units !== 0
        );
        setMfHoldingList(AMountedList ?? []);

        let sortedItem = response?.holdings?.folios?.sort((a: any, b: any) => {
          if (
            a?.schemes[0]?.holdings?.redeemable_units <
            b?.schemes[0]?.holdings?.redeemable_units
          )
            return 1;
          if (
            a?.schemes[0]?.holdings?.redeemable_units >
            b?.schemes[0]?.holdings?.redeemable_units
          )
            return -1;
          if (
            a?.schemes[0]?.market_value?.amount <
            b?.schemes[0]?.market_value?.amount
          )
            return 1;
          if (
            a?.schemes[0]?.market_value?.amount >
            b?.schemes[0]?.market_value?.amount
          )
            return -1;
        });
        setAllMfHoldingList(sortedItem ?? "");
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error);
      });
  };

  const onMorePressHandle = (index: any) => {
    setSelected(index);
    setOnMoreSelect(index);
    setOnInvestSelect(-1);
    setOnDefaultSelect(true);
    setOnRedeemSelect(-1);
  };
  const onInvestPressHandle = (index: any) => {
    if (selected === index) {
      setOnInvestSelect(index);
      setOnDefaultSelect(false);
      setOnRedeemSelect(-1);
    } else {
      setOnDefaultSelect(true);
      setOnMoreSelect(-1);
      setOnInvestSelect(-1);
      setOnRedeemSelect(-1);
    }
  };
  const onRedeemPressHandle = (index: any) => {
    if (selected === index) {
      setOnRedeemSelect(index);
      setOnMoreSelect(-1);
      setOnDefaultSelect(false);
      setOnInvestSelect(-1);
    } else {
      setOnInvestSelect(-1);
      setOnRedeemSelect(-1);
      setOnMoreSelect(-1);
      setOnInvestSelect(-1);
    }
  };
  const onCrossPressHandle = () => {
    setOnRedeemSelect(-1);
    setOnMoreSelect(-1);
    setOnInvestSelect(-1);
    setOnDefaultSelect(-1);
  };
  //add otp model
  const [openModal, setOpenModal] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // press invested
  const onpressProceedInvest = (
    types: string,
    amount: any,
    date: any,
    data: any
  ) => {
    setInvestedType(types);
    setSelectedItemData(data);
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    setselectedDate(date);
    if (types === "Sip") {
      setSipAmount(amount);
      const req: any = {
        id: userDetails.id,
        mobile: userDetails.mobile,
        partner: userDetails?.refcode,
        purpose: "purchase_mutual_fund",
        fund_name: data?.schemes[0]?.name ?? "",
        amount: amount,
      };
      otpVerifyForInvest(req);
    }
    if (types === "additional") {
      setAdditionalAmount(amount);
      const req: any = {
        id: userDetails.id,
        mobile: userDetails.mobile,
        partner: userDetails?.refcode,
        purpose: "direct_purchase",
        fund_name: data?.schemes[0]?.name ?? "",
        amount: amount,
      };
      otpVerifyForInvest(req);
    }
  };

  const otpVerifyForInvest = (req: any) => {
    let token = load("token");

    dispatch(otpGenerateForMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        toast.success(response.message);
        handleOpenModal();

        setRequestID(response?.request_id);
      })
      .catch((error: any) => {
        toast.error(
          "Unable to process your request. Please try again after sometime."
        );
      });
  };

  //process Press Redeem
  const onpressProceedRedeem = async (
    type: any,
    redeemableUnit: any,
    data: any,
    unitsToRedeem: any
  ) => {
    setUnitsForRedeemption(unitsToRedeem);
    setRedeemData(data);

    if (!(unitsToRedeem > data?.schemes[0]?.holdings?.redeemable_units)) {
      await handleRedeem(redeemableUnit, data, unitsToRedeem);
      return;
    }
    toast.error(
      `Units can not be greater than ${data?.schemes[0]?.holdings?.redeemable_units}`
    );
    return;
  };

  const handleRedeem = (redeemableUnit: any, data: any, unitsToRedeem: any) => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    if (redeemableUnit) {
      //FULL
      const req = {
        id: userDetails.id,
        mobile: userDetails.mobile,
        partner: userDetails?.refcode,
        purpose: "fund_redeem",
        fund_name: data?.schemes[0]?.name ?? "",
        no_of_units: data?.schemes[0]?.holdings?.redeemable_units,
      };
      dispatch(otpGenerateForMutualFund(req, `bearer ${token}`))
        .then(async (response: any) => {
          handleOpenModal();
          setRequestID(response.request_id);
          setIsFullRedeem(true);
        })
        .catch((error: any) => {
          toast.error(
            "Unable to process your request. Please try again after sometime."
          );
        });
    } else {
      //PARTIAL
      const req = {
        id: userDetails.id,
        mobile: userDetails.mobile,
        partner: userDetails?.refcode,
        purpose: "fund_redeem",
        fund_name: data?.schemes[0]?.name ?? "",
        no_of_units: unitsToRedeem,
      };

      dispatch(otpGenerateForMutualFund(req, `bearer ${token}`))
        .then(async (response: any) => {
          handleOpenModal();
          setRequestID(response.request_id);
          setIsFullRedeem(false);
        })
        .catch((error: any) => {
          toast.error(
            "Unable to process your request. Please try again after sometime."
          );
        });
    }
  };
  const handleShowAll = (event: any) => {
    setShowAll(event.target.checked);
    // if (event.target.checked) {
    //   setUnitsToRedeem(""); // Clear text field value when checkbox is selected
    // }
  };

  //verify OTP
  const handleSave = async (value: any) => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");

    const req = {
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      request_id: requestID,
      otp: aesEncrypt(value),
    };

    dispatch(otpVerifyForMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.message === "OTP Authenticated Successfuly") {
          if (isFullRedeem) {
            handleCloseModal();
            return redeemFullAction();
          } else if (InvestedType === "Sip") {
            handleCloseModal();
            return createSIP();
          } else if (InvestedType === "additional") {
            handleCloseModal();
            return createAdditionalOrder();
          } else {
            handleCloseModal();
            return partialRedeemAction();
          }
        } else {
          toast.error(response.message);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const createSIP = async () => {
    setLoading(true);
    let token = await load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);

    const consent: Models.ConsentRequest = {
      email: userDetails.email ?? "",
      isd_code: "91",
      mobile: userDetails?.mobile ?? "",
    };
    const req = {
      userId: userDetails.id,
      bankAccId: userDetails.bank_acc_id,
      amount: sipAmmount,
      scheme:
        (selectedItemData as { schemes?: { isin?: string }[] }).schemes?.[0]
          ?.isin ?? "",
      installmentDay: selectedDate,
      mfInvestmentAccount: userDetails.mfia_id,
      consent: consent,
    };

    dispatch(createSIPMandate(req, `${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCode === 400) {
          toast.error(
            response?.error?.message ??
              "Got error while getting a fund details, please try after sometimes!"
          );
          return;
        }
        if (response.statusCode === 200) {
          if (userDetails?.mode === "Assisted") {
            window.open(response.data.token_url, "_blank");
            navigate("/transaction", {
              state: {
                type: "mutualFund",
              },
            });
          } else {
            window.open(response.data.token_url, "_self");
          }
        }
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(
          "Got error while getting a fund details, please try after sometimes!"
        );
      });
  };

  const createAdditionalOrder = async () => {
    setLoading(true);
    let token = await load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.MutualLumpSumFundCreateOrderRequest = {
      userId:  userDetails.id,
      mobileNo: userDetails.mobile,
      userName: `${userDetails?.firstname} ${userDetails?.lastname}`,
      schemeId:  (selectedItemData as { schemes?: { isin?: string }[] }).schemes?.[0]
      ?.isin ?? "",
      schemeName: (selectedItemData as { schemes?: { isin?: string }[] }).schemes?.[0]
      ?.name ?? "",
      folioNumber: (selectedItemData as { folio_number?: string }).folio_number ?? "",
      investmentType: "ADDITIONAL_PURCHASE",
      amount: Number(additionalAmount),
      callBackUrl: process.env.REACT_APP_MF_BUY_CALL_BACK_URL || "",
    }
    // const req: Models.MutualFundCreateOrderRequest = {
    //   id: userDetails.id,
    //   mobile: userDetails.mobile,
    //   partner: userDetails?.refcode,
    //   source: "DIRECT",
    //   callbackUrl: process.env.REACT_APP_MF_BUY_CALL_BACK_URL || "",
    //   purchase_type: "ADDITIONAL PURCHASE",
    //   source_id: 0,
    //   payment_mode: "upi",
    //   orders: [
    //     {
    //       amc_code: "",
    //       isin:
    //         (selectedItemData as { schemes?: { isin?: string }[] }).schemes?.[0]
    //           ?.isin ?? "",
    //       amount: additionalAmount,
    //       folio_number:
    //         (selectedItemData as { folio_number?: string }).folio_number ?? "",
    //       user_ip: "192.168.2.92",
    //       server_ip: "192.168.2.95",
    //     },
    //   ],
    // };

    dispatch(orderLumpsumMutualFund(req, `${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCode === 400) {
          toast?.error(response?.message);
          return;
        }
        if (userDetails?.mode === "Assisted") {
          window.open(response?.data?.token_url, "_blank");
          navigate("/transaction", {
            state: {
              type: "mutualFund",
            },
          });
        } else {
          window.open(response?.data?.token_url, "_self");
        }

        setLoading(false);
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };
  const partialRedeemAction = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");

    const req = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      isin: redeemData?.schemes[0]?.isin,
      amount: (
        parseFloat(unitsForRedeemption) * redeemData?.schemes[0]?.nav?.value
      ).toString(),
      units: parseFloat(unitsForRedeemption).toString(),
      folio_number: redeemData?.folio_number,
      redeem_all: false,
    };
    await redeemMutualFundUnitsAction(req, token);
  };

  const redeemFullAction = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    const req = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      isin: redeemData?.schemes[0]?.isin,
      folio_number: redeemData?.folio_number,
      redeem_all: true,
    };
    await redeemMutualFundUnitsAction(req, token);
  };

  const redeemMutualFundUnitsAction = async (req: any, token: any) => {
    dispatch(redeemMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response?.statusCode === 400) {
          return;
        } else {
          setOnRedeemSelect(-1);
          setOnMoreSelect(-1);
          setOnDefaultSelect(true);
          setOnInvestSelect(-1);
          toast.success(response.message);
          getMutualFundHoldingTransactions();
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  return (
    <>
      {loading ? (
        <Grid
          height="100vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <>
          <DashboardNavbar />
          <Grid
            sx={{
              p: {
                md: 4,
                xs: 0,
                sm: 2,
              },
              background: "#F6F6F6",
              height: "100vh",
              paddingBottom: 0,
            }}
          >
            <OTPModel
              open={openModal}
              handleClose={handleCloseModal}
              handleSave={handleSave}
            />
            <Grid
              sx={{
                //alignItems:'center',
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: {
                    xs: 2,
                  },
                  mb: {
                    xs: -2,
                  },
                }}
              >
                <H3
                  sx={{
                    ml: 2,
                  }}
                >
                  {" "}
                  My Holdings (
                  {showAll
                    ? allMfHoldingList?.length ?? 0
                    : mfHoldingList?.length}
                  )
                </H3>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showAll}
                      onChange={handleShowAll}
                      color="primary"
                      sx={{ ml: 1 }}
                    />
                  }
                  label="Show All"
                />
              </Grid>

              {allMfHoldingList.length === 0 ? (
                <Grid
                  container
                  columns={16}
                  spacing={5}
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    height: "50vh",
                  }}
                >
                  <H4>No Holdings</H4>
                </Grid>
              ) : (
                <Grid container columns={16} spacing={5} sx={sxStyleCard}>
                  {showAll
                    ? Array?.isArray(allMfHoldingList) &&
                      allMfHoldingList?.map((item: any, index) => (
                        <MyHoldingCard
                          data={item}
                          onPressMore={() => onMorePressHandle(index)}
                          onPressInvest={() => onInvestPressHandle(index)}
                          onPressRedeem={() => onRedeemPressHandle(index)}
                          onpressProceedInvest={onpressProceedInvest}
                          onpressProceedRedeem={onpressProceedRedeem}
                          //onpressProceedRedeem={(type:any,redeemAllValue:any,unitsToRedeem:any,data:any)=>redeemClick(type,redeemAllValue,unitsToRedeem,data)}
                          onPressCross={() => onCrossPressHandle()}
                          moreValue={onMoreSelect === index ? true : false}
                          investvalue={onInvestSelect === index ? true : false}
                          redeemvalue={onRedeemSelect === index ? true : false}
                          defaultValue={
                            selected === index ? onDefaultSelect : true
                          }
                          index={index}
                        />
                      ))
                    : Array.isArray(mfHoldingList) &&
                      mfHoldingList?.map((item: any, index) => (
                        <MyHoldingCard
                          data={item}
                          onPressMore={() => onMorePressHandle(index)}
                          onPressInvest={() => onInvestPressHandle(index)}
                          onPressRedeem={() => onRedeemPressHandle(index)}
                          onpressProceedInvest={onpressProceedInvest}
                          onpressProceedRedeem={onpressProceedRedeem}
                          //onpressProceedRedeem={(type:any,redeemAllValue:any,unitsToRedeem:any,data:any)=>redeemClick(type,redeemAllValue,unitsToRedeem,data)}
                          onPressCross={() => onCrossPressHandle()}
                          moreValue={onMoreSelect === index ? true : false}
                          investvalue={onInvestSelect === index ? true : false}
                          redeemvalue={onRedeemSelect === index ? true : false}
                          defaultValue={
                            selected === index ? onDefaultSelect : true
                          }
                          index={index}
                        />
                      ))}
                </Grid>
              )}
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}

const sxStyleCard = {
  mt: {
    md: 2,
    xs: 1,
  },
  mb: {
    md: 2,
    xs: 0,
  },
  pb: 2,
  display: "flex",
  // justifyContent: "center",
  alignItems: "stretch",
  cursor: "pointer",
  p: {
    xs: 2,
  },
  pl: {
    xs: 4,
  },
  pr: {
    xs: 2,
  },
  pt: {
    xs: 0,
  },
};
